import Box, { BoxProps } from '@mui/material/Box';
import cn from 'classnames';
import React, { ReactNode } from 'react';

import s from './Container.module.scss';

interface IContainer extends BoxProps {
  children: ReactNode;
  isColumns?: boolean;
  isSpacedColumns?: boolean;
  fullHeight?: boolean;
  fullWidth?: boolean;
  withoutPadding?: boolean;
  narrowPadding?: boolean;
  verticalPadding?: boolean;
  isSpacedRows?: boolean;
  narrowWidth?: boolean;
  flexColumn?: boolean;
}

const Container = ({
  children,
  isColumns,
  isSpacedColumns,
  fullHeight,
  fullWidth,
  withoutPadding,
  narrowPadding,
  verticalPadding,
  isSpacedRows,
  narrowWidth,
  flexColumn,
  ...rest
}: IContainer) => (
  <Box
    component="section"
    {...rest}
    className={cn(s.Container, {
      isColumns,
      fullHeight,
      fullWidth,
      withoutPadding,
      narrowPadding,
      verticalPadding,
      isSpacedColumns,
      isSpacedRows,
      narrowWidth,
      flexColumn
    })}
  >
    {children}
  </Box>
);

export default Container;
